// Hides the last part of a string by substituting it by '...', if its length is too big.
export const abbreviateString = (string, maxSize) => {
  const abbreviatedString = string.substring(0, maxSize)
  if (abbreviatedString.length < string.length) {
    return `${abbreviatedString}...`
  }
  return abbreviatedString
}
